import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_14 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddCaisseModal = _resolveComponent("AddCaisseModal")!
  const _component_AffectationCaisseModal = _resolveComponent("AffectationCaisseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "btn btn-success me-2 mb-2 mb-lg-0",
            href: "#",
            "data-bs-toggle": "modal",
            "data-bs-target": "#AddCaisseModal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedItem && _ctx.resetSelectedItem(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ajouter une Caisse ")
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchCaisses && _ctx.searchCaisses(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchCaisses && _ctx.searchCaisses(...args))),
              class: "form-control shadow-none text-black",
              placeholder: "Rechercher une caisse"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.caisses.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Code"),
                    _createElementVNode("th", null, "Nom"),
                    _createElementVNode("th", null, "Utilisateurs affectés"),
                    _createElementVNode("th", null, "Point de vente"),
                    _createElementVNode("th", null, "ACTIONS")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caisses, (caisse, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(caisse.code || 'N/A'), 1),
                      _createElementVNode("td", null, _toDisplayString(caisse.nom || 'N/A'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getUsersForCaisse(caisse.id) || 'Aucun utilisateur affecté'), 1),
                      _createElementVNode("td", null, _toDisplayString(caisse.pointvente?.nomPointVente || 'N/A'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[10] || (_cache[10] = _createElementVNode("button", {
                            class: "btn btn-primary dropdown-toggle",
                            type: "button",
                            "data-bs-toggle": "dropdown"
                          }, " Actions ", -1)),
                          _createElementVNode("ul", _hoisted_9, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AffectationCaisseModal",
                                onClick: ($event: any) => (_ctx.handleAffecter(caisse))
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-shield me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.getCaisseAffectation(caisse.id) ? 'Réaffecter' : 'Affecter') + " une caisse ", 1)
                              ], 8, _hoisted_10)
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: { name: 'HistoriquePage', params: { caisseId: caisse.id } },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createElementVNode("i", { class: "flaticon-clock me-2" }, null, -1),
                                  _createTextVNode(" Historique des affectations ")
                                ])),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddCaisseModal",
                                onClick: ($event: any) => (_ctx.modification(caisse))
                              }, _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-pen me-2" }, null, -1),
                                _createTextVNode("Modifier ")
                              ]), 8, _hoisted_11)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center text-danger",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(caisse.id, _ctx.caisses, 'caisses', `la caisse ${caisse.nom}`))
                              }, _cache[9] || (_cache[9] = [
                                _createElementVNode("i", { class: "fa fa-trash-o me-2" }, null, -1),
                                _createTextVNode("Supprimer ")
                              ]), 8, _hoisted_12)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, " Aucune caisse trouvée "))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.currentPage,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddCaisseModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpenmodal: _ctx.handleOpenModal
    }, null, 8, ["item", "onClose", "onOpenmodal"]),
    _createVNode(_component_AffectationCaisseModal, {
      selectedUser: _ctx.selectedUser,
      selectedCaisse: _ctx.selectedCaisse,
      selectedAffectation: _ctx.selectedAffectation,
      onAffectee: _ctx.recharger,
      onOpenmodal: _ctx.handleOpenModal
    }, null, 8, ["selectedUser", "selectedCaisse", "selectedAffectation", "onAffectee", "onOpenmodal"])
  ], 64))
}